import { useEffect, useState } from "react";

const getViewportMode = () => {
  if (typeof window === "undefined") {
    return "desktop";
  }

  const width = window.innerWidth;

  if (width <= 599) return "mobile";
  if (width <= 1024) return "tablet";
  return "desktop";
};

export default function useViewportMode() {
  const [viewportMode, setViewportMode] = useState(getViewportMode);

  useEffect(() => {
    const handleResize = () => {
      setViewportMode(getViewportMode());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    viewportMode,
    isMobile: viewportMode === "mobile",
    isTablet: viewportMode === "tablet",
    isTouchLayout: viewportMode !== "desktop",
  };
}
